import { render, staticRenderFns } from "./ShippingCategoryAdditionalFeeCreate.vue?vue&type=template&id=54a1a45b&"
import script from "./ShippingCategoryAdditionalFeeCreate.vue?vue&type=script&lang=js&"
export * from "./ShippingCategoryAdditionalFeeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports